// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b0010fb0","622":"6dc710ec","977":"b23ef1b6"}[chunkId] + ".chunk.js";
};